module.exports = __webpack_public_path__ + "static/side-51e615d50e9336d0d8dd117d8799aa8a.png";